export default {"src":"/_next/static/media/404.2263975d.svg","height":437,"width":652,"blurWidth":0,"blurHeight":0};